export enum FieldTypes {
  AutoComplete = 'autocomplete',
  Button = 'button',
  Submit = 'submit',
  CheckBox = 'checkbox',
  DataGrid = 'datagrid',
  Table = 'table',
  DatePicker = 'datepicker',
  DateCombo = 'datepicker',
  ComboBox = 'dropdown',
  DropDown = 'dropdown',
  File = 'file',
  Img = 'img',
  Input = 'text',
  Text = 'text',
  Email = 'email',
  Number = 'number',
  Time = 'time',
  Password = 'password',
  Radio = 'radio',
  Currency = 'currency',
  Unit = 'unit',
  Id = 'id',
  PageViewer = 'pageviwer',
}
